import { z } from "zod";
import { createLocalStore } from "../../../lib/store";

export const usePublicationSearchCompleted = createLocalStore(
  "publication-search-completed",
  false,
  z.boolean()
);
